import { ExperimentProvider } from '@eneco/experiments';
import { Layout } from '@eneco/flows/components';
import { createFlowProvider } from '@eneco/flows/utils';
import { FeaturesReady } from '@growthbook/growthbook-react';

import { FlowConsumerContextEnergy } from './context';
import { routes, actions, initialContext } from './EnergyFlowOxxio.config';

const { Provider, Navigation, Router } = createFlowProvider<FlowConsumerContextEnergy>({
  routes,
  actions,
  initialContext,
});

const Flow = () => {
  return (
    <ExperimentProvider>
      <FeaturesReady fallback={null} timeout={1000}>
        <Provider>
          <Layout>
            <Layout.Header>
              <Navigation componentName="Navigation" />
            </Layout.Header>
            <Router />
          </Layout>
        </Provider>
      </FeaturesReady>
    </ExperimentProvider>
  );
};

export default Flow;
